import { IQueryClassDependency } from '@kurtosys/types/dependencies/IQueryClassDependency.js';
import { ITransformClassDependency } from '@kurtosys/types/dependencies/ITransformClassDependency.js';
import { IExecutionOptions } from '@kurtosys/types/query/IExecutionOptions.js';
import { IQueryOptions } from '@kurtosys/types/query/IQueryOptions.js';
import { IQueryOptionsAllocations } from '@kurtosys/types/query/options/IQueryOptionsAllocations.js';

import { helpers } from '../../common/index.js';

import { BaseValueCollectionQuery } from './base/BaseValueCollectionQuery.js';

export class AllocationsQuery extends BaseValueCollectionQuery<IQueryOptionsAllocations> {
	constructor(
		public dependencies: IQueryClassDependency & ITransformClassDependency,
		public queryOptions: IQueryOptions,
		public translationHelper?: helpers.TranslationHelper,
	) {
		super(dependencies, queryOptions, translationHelper);
	}

	initialize(executionOptions: IExecutionOptions): void {
		this.fillKeyFromQuery('code', 'codeQuery', executionOptions);
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsAllocations {
		const {
			entityType,
			entityConditional,
			code,
			codeQuery,
			key,
			keyQuery,
			collectionItemConditional,
			collectionItemValueConditional,
			sort,
			index,
			startIndex,
			endIndex,
			entityKey,
			entityIndex,
			options = {},
		} = this.queryOptions;
		return {
			entityType,
			entityConditional,
			code,
			codeQuery,
			key,
			keyQuery,
			collectionItemConditional,
			collectionItemValueConditional,
			sort,
			index,
			startIndex,
			endIndex,
			entityKey,
			entityIndex,
			...(options.allocations || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		return this.getRawValueOrRootKey(executionOptions);
	}
}
